import React, { useContext } from 'react';
import { navBarStyles } from './style';
import clsx from 'clsx';
import { CustomBreadcrumbs, CustomHelmet } from 'components';
import { UserInfo } from './userInfo';
import { AppBar, Toolbar } from '@mui/material';
import { DrawerContext, getMenuTitle, PermissionList, renderClientName, renderStaffName, RolePermission, User } from 'utils';
import { useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { SearchInput } from './common/searchInput';
import { SearchFromSystem } from './common/searchFromSystem';
import { AiAssistantButton } from '../../aiAssistant';

export const TopBar = () => {
    const { staffGeneral, fsData, client, form, therapySession } = useSelector((state) => ({
        staffGeneral: state.admins.adminInfoById,
        fsData: state.fundingSource.fundingSourceItem,
        client: state.client.clientItemInfo,
        form: state.forms.form,
        therapySession: state.auth.therapySession,
    }));
    const classes = navBarStyles();
    const url = window.location.pathname;
    const menuTittle = getMenuTitle(url);
    const { open } = useContext(DrawerContext);
    const location = useLocation();
    const originalPath = location?.pathname?.split('/')[1];
    const checkHelpCenter = location?.pathname === '/help-center';
    const navigate = useNavigate();
    const info = location?.state;
    const { userInfo } = User();
    const isDashboard = location?.pathname === '/' || location?.pathname === '/dashboard';

    const renderLinks = () => {
        if (originalPath === 'fundingSource') {
            return { parent: 'Payer', child: fsData?.name, parentLink: '/fundingSource' };
        }
        if (originalPath === 'staff') {
            return {
                parent: 'Staff',
                child: staffGeneral ? renderStaffName(staffGeneral) : null,
                parentLink: '/staff',
            };
        }
        if (location?.pathname === '/client/authorization-utilization') {
            return { parent: 'Client', child: 'Authorization Utilization', parentLink: '/client' };
        }
        if (originalPath === 'client') {
            return {
                parent: 'Client',
                child: client ? renderClientName(client) : null,
                parentLink: '/client',
            };
        }
        if (originalPath === 'claim') {
            return {
                parent: 'Claims',
                child: 'Claim Details',
                parentLink: '/claims',
                saveParams: { tabType: info?.tabType },
            };
        }
        if (originalPath === 'completed-claim') {
            return {
                parent: 'Claims',
                child: 'Completed Claims',
                parentLink: '/claims',
                saveParams: { tabType: info?.tabType },
            };
        }
        if (originalPath === 'billedClaim') {
            return {
                parent: 'Claims',
                child: 'Claim Details',
                parentLink: '/claims',
                saveParams: { tabType: info?.tabType },
            };
        }
        if (originalPath === 'invoice') {
            return {
                parent: 'Invoices',
                child: 'Invoice Details',
                parentLink: '/invoices',
                saveParams: { tabType: info?.tabType },
            };
        }
        if (originalPath === 'generateInvoice') {
            return { parent: 'Invoices', child: 'Generate Invoice', parentLink: '/invoices' };
        }
        if (originalPath === 'timesheet') {
            return {
                parent: 'Payroll',
                child: 'Payroll Details',
                parentLink: '/timesheet',
                saveParams: { tabType: info?.tabType },
            };
        }
        if (originalPath === 'help-center') {
            return { parent: 'App', child: 'Help Center', parentLink: '/' };
        }

        if (originalPath === 'resource') {
            return { parent: 'Folder', child: 'Folder Details', parentLink: '/resource' };
        }
        if (originalPath === 'template') {
            return { parent: 'Templates', child: form?.title, parentLink: '/templates' };
        }
        // if (originalPath === 'create-form') {
        //     return { parent: 'Templates', child: 'Create Template', parentLink: '/templates' };
        // }
        // if (originalPath === 'completed-claim') {
        //     return { parent: 'Completed Claims', child: 'Claim Details', parentLink: '/completed-claims' };
        // }
        if (originalPath === 'claim-payment') {
            return { parent: 'Claim Payments', child: 'Claim Payment Details', parentLink: '/claimPayments' };
        }
    };

    const checkSearch = () => {
        return (
            location?.pathname === '/schedule' ||
            (location?.pathname === '/claims' && info?.tabType && info?.tabType !== 'BILLABLE') ||
            location?.pathname === '/invoices' ||
            location?.pathname === '/claimPayments' ||
            location?.pathname === '/activePayroll' ||
            location?.pathname === '/client/authorization-utilization'
        );
    };

    const searchFromSystem = () => {
        // This page filters by its own "Search clients" box; the client-code jump box would be a second search.
        if (location?.pathname === '/client/authorization-utilization') return false;
        if (
            (location?.pathname === '/fundingSource' || originalPath === 'fundingSource') &&
            RolePermission([PermissionList.FS_READ?.code])
        ) {
            return true;
        }
        if ((location?.pathname === '/staff' || originalPath === 'staff') && RolePermission([PermissionList.STAFF_READ?.code])) {
            return true;
        }
        if ((location?.pathname === '/client' || originalPath === 'client') && RolePermission([PermissionList.CLIENT_READ?.code])) {
            return true;
        }
    };

    return (
        <AppBar position="fixed" className={clsx(classes.appBar, { [classes.appBarShift]: open })}>
            <Toolbar className={classes.headerContent}>
                <div className={classes.Toolbar}>
                    <div className={checkHelpCenter ? '' : open === true ? classes.openToolbar : classes.closeToolbar}>
                        {menuTittle === 'detail' ? (
                            renderLinks()?.child ? (
                                <CustomBreadcrumbs
                                    parent={renderLinks()?.parent}
                                    child={renderLinks()?.child}
                                    parentLink={renderLinks()?.parentLink}
                                    saveParams={renderLinks()?.saveParams}
                                />
                            ) : null
                        ) : isDashboard ? (
                            <>
                                <CustomHelmet title={'Dashboard'} />
                                <div className={classes.dashboardWelcomeBox}>
                                    <p className={classes.dashboardWelcomeTitle}>Welcome back, {userInfo?.firstName} 👋</p>
                                    <p className={classes.dashboardWelcomeSubtitle}>Here’s what’s coming up next</p>
                                </div>
                            </>
                        ) : (
                            <>
                                <CustomHelmet title={menuTittle} />
                                <p className={classes.getMenuTitle}>{menuTittle}</p>
                            </>
                        )}
                    </div>

                    <div className={classes.userActionsBoxStyle}>
                        {checkSearch() && <SearchInput />}
                        {searchFromSystem() && <SearchFromSystem />}
                        <AiAssistantButton />
                        <UserInfo />
                    </div>
                </div>
            </Toolbar>
        </AppBar>
    );
};
